'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n    width: 200px;\n    background: #FFFFFF;\n    padding: 10px 0 5px 20px;\n'], ['\n    width: 200px;\n    background: #FFFFFF;\n    padding: 10px 0 5px 20px;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    text-align: left;\n    padding-bottom: 16px;\n    font-family: ', ';\n    font-size: 20px;\n    color: #3E2723;\n    letter-spacing: 0;\n'], ['\n    text-align: left;\n    padding-bottom: 16px;\n    font-family: ', ';\n    font-size: 20px;\n    color: #3E2723;\n    letter-spacing: 0;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n    font-family: ', ';\n    text-align: left;\n    font-size: 12px;\n    color: #3E2723;\n    letter-spacing: 0;\n    line-height: 20px;\n'], ['\n    font-family: ', ';\n    text-align: left;\n    font-size: 12px;\n    color: #3E2723;\n    letter-spacing: 0;\n    line-height: 20px;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n    font-family: ', ';\n    color: #6E4D40;\n    padding-top: 20px;\n'], ['\n    font-family: ', ';\n    color: #6E4D40;\n    padding-top: 20px;\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsHelper = require('../../lib/styledComponentsHelper');

var _commonWebLocalization = require('../../localization/commonWebLocalization');

var _commonWebLocalization2 = _interopRequireDefault(_commonWebLocalization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var InfoContainer = _styledComponents2.default.div(_templateObject);

var TitleStyled = _styledComponents2.default.div(_templateObject2, _styledComponentsHelper.fontFamilies.bold);

var InfoStyled = _styledComponents2.default.div(_templateObject3, _styledComponentsHelper.fontFamilies.regular);

var Hours = _styledComponents2.default.div(_templateObject4, _styledComponentsHelper.fontFamilies.bold);

var InfoWindowContent = function InfoWindowContent(props) {
    var location = props.selectedLocation;
    var template = _react2.default.createElement('div', null);

    if (props.mapLoaded && !!location) {
        var hours = !!location.hours ? _react2.default.createElement(
            Hours,
            null,
            _commonWebLocalization2.default.get('card_hours_open'),
            location.hours
        ) : '';

        template = _react2.default.createElement(
            InfoContainer,
            null,
            _react2.default.createElement(
                TitleStyled,
                null,
                location.title
            ),
            _react2.default.createElement(
                InfoStyled,
                null,
                _react2.default.createElement(
                    'div',
                    null,
                    '#',
                    location.id
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    location.address1
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    location.address2
                ),
                hours
            )
        );
    }

    return template;
};

InfoWindowContent.propTypes = {
    mapLoaded: _propTypes2.default.bool,
    selectedLocation: _propTypes2.default.object
};

InfoWindowContent.defaultProps = {
    mapLoaded: false,
    selectedLocation: null
};

exports.default = InfoWindowContent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/InfoWindowContent/index.js
// module id = 820
// module chunks = 0